import component from "./VideoContainer";
export default component;
